// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__9dkW7","title":"Images45_title__39VpV","images":"Images45_images__3thIG"};